/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAdv.vue?vue&type=template&id=5f6fb670&scoped=true"
import script from "./popAdv.vue?vue&type=script&lang=js"
export * from "./popAdv.vue?vue&type=script&lang=js"
import style0 from "./popAdv.vue?vue&type=style&index=0&id=5f6fb670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fb670",
  null
  
)

export default component.exports